import React from 'react'
import { connect } from 'react-redux'
import Modal from '../../components/modal/modal'
import { bindActionCreators } from 'redux'
import moment from 'moment'
import { Switch } from '@material-ui/core'
import { Grid } from '@material-ui/core'
import idx from 'idx'
import { warningSnackBar } from '../../actions/common.action'
import CustomTable from '../../components/table/table'
import { modifyAllocation } from 'src/actions/timesheet.action'

class ConfirmAllocateResource extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            list: [],
            data: {},
            type: '',
            prevType: '',
            startDate: '',
            finishDate: '',
        }
    }

    componentDidMount() {
        const { data } = this.props
        let allocationData = []
        const allocationList = idx(data, _ => _.list) || []
        for (let [index, allocation] of allocationList.entries()) {
            allocationData.push({
                id: index,
                ...allocation,
                status: allocation['allocation_status'] ? `Not Available (${allocation['allocation_status']})` : 'Available',
                selected: allocation['allocation_status'] ? false : true,
                disabled: allocation['allocation_status'] ? true : false,
            })
        }
        const allocateData = data.allocateData
        this.setState({
            list: allocationData,
            type: idx(allocateData, _ => _.allocationType) || '',
            prevType: idx(allocateData, _ => _.previousType) || '',
            startDate: idx(allocateData, _ => _.startTime) || '',
            finishDate: idx(allocateData, _ => _.endTime) || '',
            data: allocateData
        })
    }

    getColumns = () => {
        return ([
            {
                title: 'S No',
                field: 'id',
                render: rowData => (rowData.id + 1)
            },
            {
                title: 'Start Time',
                field: 'start_time',
                render: rowData => `${moment.utc(rowData.start_time).format('DD-MM-YYYY')} ${moment.utc(rowData.start_time).format('HH:mm')}`
            },
            {
                title: 'Finish Time',
                field: 'end_time',
                render: rowData => `${moment.utc(rowData.end_time).format('DD-MM-YYYY')} ${moment.utc(rowData.end_time).format('HH:mm')}`
            },
            { title: 'Status', field: 'status' },
            {
                title: 'Allocate',
                field: 'selected',
                render: rowData => (<Switch
                    checked={rowData.selected}
                    color='primary'
                    disabled={rowData.disabled}
                    onChange={(e) => this.handleSelection(e.target.checked, rowData.id)}
                />)
            },
        ])
    }

    handleSelection = (value, id) => {
        this.setState(prevState => ({
            list: prevState.list.map(item =>
                item.id === id ? { ...item, selected: value } : item
            )
        }))
    }

    submitData = () => {
        const { list, data } = this.state;
        const req = {
            allocationType: data.allocationType,
            userId: data.userId,
            allocations: []
        };

        if (data.allocationId) {
            req.allocationId = data.allocationId;
        }
        list.forEach(item => {
            if (!item.disabled && item.selected) {
                req.allocations.push({
                    startTime: item.start_time || data.startTime,
                    endTime: item.end_time || data.endTime,
                    projectId: data.projectId,
                    projectType: data.projectType,
                    taskId: data.taskId,
                    taskType: data.taskType,
                    taskName: data.taskName,
                    allDayWithBreaks: data.allDayWithBreaks,
                    hourlyRate: data.hourlyRate || 0
                });
            }
        });

        if (req.allocations.length === 0) {
            this.props.warningSnackBar('Please select at least one allocation to proceed');
            return;
        }
        if (req.allocationId) {
            this.props.modifyAllocation(req)
                .then(response => {
                    this.props.dialogClose();
                    this.props.getAllocations && this.props.getAllocations();
                })
                .catch(error => {
                    this.props.warningSnackBar('Error modifying allocation: ' + error.message);
                });
        } else {
            this.props.allocateSchedule(req)
                .then(response => {
                    this.props.dialogClose();
                })
                .catch(error => {
                    this.props.warningSnackBar('Error adding allocation: ' + error.message);
                });
        }
    };

    render() {
        const { open, dialogClose } = this.props
        const { list, type, prevType, startDate, finishDate } = this.state
        return (
            <Modal
                open={open}
                onClose={dialogClose}
                fullWidth
                maxWidth='md'
                modalHeading={'Confirm Allocations'}
                modalSaveTxt={'Confirm'}
                modalCloseTxt='Cancel'
                onClick={this.submitData}
                savebtnClass='createBtn'
                showActionBtn={true}
                primary
            >
                <div>
                    <Grid container style={{ marginBottom: "10px" }}>
                        <Grid sm={3} xs={6} item><p style={{ margin: "8px 20px" }}>Allocation Type</p></Grid>
                        <Grid sm={5} xs={6} item><p style={{ margin: "8px 0" }}>: {type}</p></Grid>
                    </Grid>
                    {prevType && type !== prevType && <Grid container style={{ marginBottom: "10px" }}>
                        <Grid sm={3} xs={6} item><p style={{ margin: "8px 20px" }}>Previous Allocation Type</p></Grid>
                        <Grid sm={5} xs={6} item><p style={{ margin: "8px 0" }}>: {prevType}</p></Grid>
                    </Grid>}
                    {startDate && <Grid container style={{ marginBottom: "10px" }}>
                        <Grid sm={3} xs={6} item><p style={{ margin: "8px 20px" }}>Start Time</p></Grid>
                        <Grid sm={5} xs={6} item><p style={{ margin: "8px 0" }}>: {`${moment.utc(startDate).format('DD-MM-YYYY')} ${moment.utc(startDate).format('HH:mm')}`}</p></Grid>
                    </Grid>}
                    {finishDate && <Grid container style={{ marginBottom: "10px" }}>
                        <Grid sm={3} xs={6} item><p style={{ margin: "8px 20px" }}>End Time</p></Grid>
                        <Grid sm={5} xs={6} item><p style={{ margin: "8px 0" }}>: {`${moment.utc(finishDate).format('DD-MM-YYYY')} ${moment.utc(finishDate).format('HH:mm')}`}</p></Grid>
                    </Grid>}
                    <div className='tableContainer'>
                        <CustomTable
                            columns={this.getColumns()}
                            data={list}
                            toolbar={false}
                        />
                    </div>
                </div>
            </Modal>
        )
    }
}

const mapStateToProps = state => ({})

const mapDispatchToProps = dispatch => ({
    warningSnackBar: bindActionCreators(warningSnackBar, dispatch),
    modifyAllocation: bindActionCreators(modifyAllocation, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmAllocateResource)
